export default "__VITE_ASSET__DICF1zEr__"